import {lazy} from 'react';

const AgencyPerformanceReport = lazy(() => import('./AgencyPerformanceReport'));
const HRAttritionMany = lazy(() =>
  import('./OneToManyReportDashboard/HRAttritionOneToMany'),
);
const HRAttendanceMany = lazy(() =>
  import('./OneToManyReportDashboard/HRAttendanceOneToMany'),
);

const HRWorkExperienceMany = lazy(() =>
  import('./OneToManyReportDashboard/HRWorkExperienceOneToMany'),
);

const HRWorkExperience = lazy(() =>
  import('./OneToOneReportDashboard/HRWorkExperience'),
);
const HRAttendance = lazy(() =>
  import('./OneToOneReportDashboard/HRAttendance'),
);
const HRAttrition = lazy(() => import('./OneToOneReportDashboard/HRAttrition'));
const SupDetailsOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/SupDetailsOneToMany'),
);
const SupSummary = lazy(() =>
  import('./OneToOneReportDashboard/SupSummaryReport'),
);
const SupDetails = lazy(() => import('./OneToOneReportDashboard/SupDetails'));
const AgencyDetails = lazy(() =>
  import('./OneToOneReportDashboard/AgencyDetails'),
);
const AgencyDetailsOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/AgencyDetailsOneToMany'),
);
const SingleAttendance = lazy(() =>
  import('./OneToOneReportDashboard/AttendanceReport/SingleAttandance'),
);
const OneToOneDashboard = lazy(() => import('./OneToOneReportDashboard'));
const OneToManyDashboard = lazy(() => import('./OneToManyReportDashboard'));
const DailyReportOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/DailyReportOneToMany'),
);
const DetailReportPromoterOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/DetailReportPromoterOneToMany'),
);
const SupSummaryOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/SupSummaryReportOneToMany'),
);
const AgencySummaryOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/AgencySummaryOneToMany'),
);
const HRReportOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/HRReportOneToMany'),
);
const HistoricalDataOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/HistoricalDataOneToMany'),
);
const OnGoingActivitiesOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/OnGoingActivitiesOneToMany'),
);
const AttendanceSummaryOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/AttendanceSummaryOneToMany'),
);
const PromoterSummaryOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/PromoterSummaryOneToMany'),
);
const SingleAttendanceOneToMany = lazy(() =>
  import(
    './OneToManyReportDashboard/AttendanceSummaryOneToMany/SingleAttendanceOneToMany'
  ),
);
const DailyReport = lazy(() => import('./OneToOneReportDashboard/DailyReport'));
const DetailReportPromoter = lazy(() =>
  import('./OneToOneReportDashboard/DetailReportPromoter'),
);
const AgencySummary = lazy(() =>
  import('./OneToOneReportDashboard/AgencySummary'),
);
const CampaignSummary = lazy(() =>
  import('./OneToOneReportDashboard/CampaignSummary'),
);
const HRReport = lazy(() => import('./OneToOneReportDashboard/HRReport'));
const HistoricalData = lazy(() =>
  import('./OneToOneReportDashboard/HistoricalData'),
);
const OnGoingActivities = lazy(() =>
  import('./OneToOneReportDashboard/OnGoingActivities'),
);
const PromoterSummary = lazy(() =>
  import('./OneToOneReportDashboard/PromoterSummary'),
);
const AttendanceSummary = lazy(() =>
  import('./OneToOneReportDashboard/AttendanceReport'),
);
const SessionImageOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/SessionImageOneToMany'),
);
const LiveUpdateReport = lazy(() => import('./LiveUpdateReport'));
const FloatingBPSummary = lazy(() =>
  import('./OneToManyReportDashboard/FloatingBPSummary'),
);
const FloatingBPDetails = lazy(() =>
  import('./OneToManyReportDashboard/FloatingBPSummary/FloatingBPDetails'),
);
const SalesProximity = lazy(() =>
  import('./OneToOneReportDashboard/SalesProximity'),
);
const SalesProximityOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/SalesProximityOneToMany'),
);
const ConsumerDetailsOneToMany = lazy(() =>
  import('./OneToManyReportDashboard/ConsumerDetailsOneToMany'),
);
const ConsumerDetailsOneToOne = lazy(() =>
  import('./OneToOneReportDashboard/ConsumerDetailsOneToOne'),
);

export const UBLReportsConfig = [
  {
    path: '/dashboard/one-to-one/daily-report',
    element: <DailyReport />,
  },
  {
    path: '/dashboard/one-to-one/detail-promoter',
    element: <DetailReportPromoter />,
  },
  {
    path: '/dashboard/one-to-one/sup-summary',
    element: <SupSummary />,
  },
  {
    path: '/dashboard/one-to-one/agency-summary',
    element: <AgencySummary />,
  },
  {
    path: '/dashboard/one-to-one/agency-details/:id',
    element: <AgencyDetails />,
  },
  {
    path: '/dashboard/one-to-one/campaign-summary',
    element: <CampaignSummary />,
  },
  {
    path: '/dashboard/one-to-one/hr-report',
    element: <HRReport />,
  },
  {
    path: '/dashboard/one-to-one/historical-data',
    element: <HistoricalData />,
  },
  {
    path: '/dashboard/one-to-one/ongoing-activities',
    element: <OnGoingActivities />,
  },
  {
    path: '/dashboard/one-to-one/attendance-report',
    element: <AttendanceSummary />,
  },
  {
    path: '/dashboard/live-update-report',
    element: <LiveUpdateReport />,
  },
  {
    path: '/dashboard/agency-performance-report',
    element: <AgencyPerformanceReport />,
  },
  {
    path: '/dashboard/one-to-one/sup-details/:id',
    element: <SupDetails />,
  },
  {
    path: '/dashboard/one-to-one/promoter-summary',
    element: <PromoterSummary />,
  },
  {
    path: '/dashboard/one-to-one/sales-proximity',
    element: <SalesProximity />,
  },
  {
    path: '/dashboard/one-to-one/ff-attendance-report/:id',
    element: <SingleAttendance />,
  },
  {
    path: '/dashboard/one-to-one/consumer-details',
    element: <ConsumerDetailsOneToOne />,
  },
  {
    path: '/dashboard/one-to-many/daily-report',
    element: <DailyReportOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/detail-promoter',
    element: <DetailReportPromoterOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/sup-summary',
    element: <SupSummaryOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/agency-summary',
    element: <AgencySummaryOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/campaign-summary',
    element: <CampaignSummary />,
  },
  {
    path: '/dashboard/one-to-many/hr-report',
    element: <HRReportOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/historical-data',
    element: <HistoricalDataOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/ongoing-activities',
    element: <OnGoingActivitiesOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/attendance-report',
    element: <AttendanceSummaryOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/promoter-summary',
    element: <PromoterSummaryOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/ff-attendance-report/:id',
    element: <SingleAttendanceOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/agency-details/:id',
    element: <AgencyDetailsOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/sup-details/:id',
    element: <SupDetailsOneToMany />,
  },
  {
    path: '/dashboard/one-to-one',
    element: <OneToOneDashboard />,
  },
  {
    path: '/dashboard/one-to-many',
    element: <OneToManyDashboard />,
  },
  {
    path: '/dashboard/one-to-one/hr-attrition',
    element: <HRAttrition />,
  },
  {
    path: '/dashboard/one-to-one/hr-attendance',
    element: <HRAttendance />,
  },
  {
    path: '/dashboard/one-to-one/hr-work-experience',
    element: <HRWorkExperience />,
  },
  {
    path: '/dashboard/one-to-many/hr-attrition',
    element: <HRAttritionMany />,
  },
  {
    path: '/dashboard/one-to-many/hr-attendance',
    element: <HRAttendanceMany />,
  },
  {
    path: '/dashboard/one-to-many/hr-work-experience',
    element: <HRWorkExperienceMany />,
  },
  {
    path: '/dashboard/one-to-many/session-image',
    element: <SessionImageOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/floating-bp-summary',
    element: <FloatingBPSummary />,
  },
  {
    path: '/dashboard/one-to-many/floating-bp-details',
    element: <FloatingBPDetails />,
  },
  {
    path: '/dashboard/one-to-many/sales-proximity',
    element: <SalesProximityOneToMany />,
  },
  {
    path: '/dashboard/one-to-many/consumer-details',
    element: <ConsumerDetailsOneToMany />,
  },
];
